import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import Menu from '~/src/components/Menu';

export const Wrapper = styled.div`
    display: block;
    width: 100%;
    overflow: hidden;
    @media (max-width: 859px) {
        padding-top: 56px;
    }
`;

export const Container = GridContainer;

export const TitleContainer = styled(Container)`
    margin-bottom: 37px;
`;

export const PromoSubtitle = styled.div`
    display: block;
    max-width: 550px;
    ${FONTS.S};
    color: ${COLORS.darkGrey};
    a {
        display: inline;
    }
    @media (max-width: 1179px) {
        margin-bottom: 20px;
        max-width: 100%;
    }
`;

export const BannerSection = styled.div`
    display: block;
    margin-bottom: 50px;
    width: 100%;
`;

export const QuizSection = styled.div`
    display: block;
    padding-bottom: 30px;
    margin-bottom: 18px;
`;

export const TariffMenu = styled(Menu)`
  margin-bottom: 0;
`;
